import { ComponentType, lazy, Suspense, useState } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { loggedInState } from "../../states/accountState";
import { isGoogleProviderState } from "../../states/mapState";
import { detectFormFactor, readFormFactorInput } from "../../utils/formFactor";

// a failed download only loses the head start: the dashboard then loads the map itself, as before
const EarlyGoogleMaps = lazy((): Promise<{ default: ComponentType }> =>
    import("./EarlyGoogleMaps").catch(() => ({ default: () => null })));

/** Addresses with a page of their own; every other address opens the dashboard. */
const NOT_DASHBOARD = /^\/(login|signup|chat|ama|forms|integrations|!|share|go|demo|sso|switch|support|approve|logout|continue|codispatch|dev)(\/|$)/;

/**
 * Loads Google Maps as soon as the app's own code runs, for someone signed in on a dashboard
 * address, so the map can draw while the splash is still up. Sits outside the routes' Suspense:
 * inside it, it would wait for the dashboard's code like everything else.
 */
export function StartMapEarly() {
    const { pathname } = useLocation();
    const loggedIn = useRecoilValue(loggedInState);
    const isGoogle = useRecoilValue(isGoogleProviderState);
    // phones open their own shell
    const [phone] = useState(() => detectFormFactor(readFormFactorInput()) === "phone");

    if (!loggedIn || !isGoogle || phone || NOT_DASHBOARD.test(pathname)) {
        return null;
    }
    return (
        <Suspense fallback={null}>
            <EarlyGoogleMaps/>
        </Suspense>
    );
}
